<template>
    <CarouselDraggable>
        <template #items>
            <SpecialistCard
                v-for="specialist in specialists"
                :key="specialist.specialist_img"
                :specialist="specialist"
                :class="{ 'hidden': !isShowing && specialist.eliminado }"
            />
        </template>
    </CarouselDraggable>
</template>

<script setup>
import { ref } from 'vue';
import { useEliminatedFromBBB } from '@/composables/useEliminatedFromBBB';
import CarouselDraggable from "@/Components/CarouselDraggable.vue";
import SpecialistCard from "@/Components/Home/SpecialistsTeam/SpecialistCard.vue";

const { isShowing } = useEliminatedFromBBB();

const specialists = ref([
    {
        'specialist_name': 'Felipe Viana',
        'specialist_position': 'Project Manager',
        'specialist_img': 'FelipeViana.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Paulo Handerson',
        'specialist_position': 'Project Manager',
        'specialist_img': 'PauloHanderson.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Rafael Miranda',
        'specialist_position': 'Developer',
        'specialist_img': 'RafaelMiranda.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Felipe Nogueira',
        'specialist_position': 'Developer',
        'specialist_img': 'FelipeNogueira.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Eduardo Vasconcelos',
        'specialist_position': 'Developer',
        'specialist_img': 'EduardoVasconcelos.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Vitor Nunes',
        'specialist_position': 'Developer',
        'specialist_img': 'VitorNunes.png',
        'eliminado': true,
    },
    {
        'specialist_name': 'Emanuel Cavalcante',
        'specialist_position': 'Developer',
        'specialist_img': 'EmanuelCavalcante.png',
        'eliminado': true,
    },
    {
        'specialist_name': 'Lucas Araripe',
        'specialist_position': 'Developer',
        'specialist_img': 'LucasAraripe.png',
        'eliminado': true,
    },
    {
        'specialist_name': 'Thainá Goes',
        'specialist_position': 'Developer',
        'specialist_img': 'ThainaGoes.png',
        'eliminado': true,
    },
    {
        'specialist_name': 'Fernanda dos Anjos',
        'specialist_position': 'Analista Financeira',
        'specialist_img': 'FernandaAnjos.png',
        'eliminado': false,
    },
    {
        'specialist_name': 'Julia Holanda',
        'specialist_position': 'UI/UX Designer',
        'specialist_img': 'JuliaHolanda.png',
        'eliminado': true,
    },
    {
        'specialist_name': 'Ricardo Maia',
        'specialist_position': 'Analista de Marketing',
        'specialist_img': 'RicardoMaia.png',
        'eliminado': true,
    },
]);
/*
import CarouselDraggable from "../../CarouselDraggable.vue";
import SpecialistCard from "./SpecialistCard.vue";

export default {
    components:{
        CarouselDraggable,
        SpecialistCard
    },
    data(){
        return {
            specialists:[
                {
                    'specialist_name':'Felipe Viana',
                    'specialist_position':'CEO',
                    'specialist_img':'FelipeViana.png'
                },
                {
                    'specialist_name':'Paulo Handerson',
                    'specialist_position':'Project Manager',
                    'specialist_img':'PauloHanderson.png'
                },
                {
                    'specialist_name':'Rafael Miranda',
                    'specialist_position':'Developer',
                    'specialist_img':'RafaelMiranda.png'
                },
                {
                    'specialist_name':'Felipe Nogueira',
                    'specialist_position':'Developer',
                    'specialist_img':'FelipeNogueira.png'
                },
                {
                    'specialist_name':'Vitor Nunes',
                    'specialist_position':'Developer',
                    'specialist_img':'VitorNunes.png'
                },
                {
                    'specialist_name':'Emanuel Cavalcante',
                    'specialist_position':'Developer',
                    'specialist_img':'EmanuelCavalcante.png'
                },
                {
                    'specialist_name':'Lucas Araripe',
                    'specialist_position':'Developer',
                    'specialist_img':'LucasAraripe.png'
                },
                {
                    'specialist_name':'Thainá Goes',
                    'specialist_position':'Developer',
                    'specialist_img':'ThainaGoes.png'
                },
                {
                    'specialist_name':'Fernanda dos Anjos',
                    'specialist_position':'Analista Financeira',
                    'specialist_img':'FernandaAnjos.png'
                },
                {
                    'specialist_name':'Julia Holanda',
                    'specialist_position':'UI/UX Designer',
                    'specialist_img':'JuliaHolanda.png'
                },
                {
                    'specialist_name':'Ricardo Maia',
                    'specialist_position':'Analista de Marketing',
                    'specialist_img':'RicardoMaia.png'
                },
            ],
        }
    },
}
*/
</script>
